export const booleanPlanPropertiesMapper = {
    acuteCareVisits: "Acute Care Visits",
    unlimitedOfficeVisits: 'Unlimited Primary Care Visits',
    sameDayAvailability: 'Same Day Availability',
    availableBusinessHours: 'Physician Access During Business Hours',
    availableAllHours: '24-Hour Access by Phone/Text/Email',
    urgentCareInOfficeIncluded: 'After Hours Urgent Care In Office',
    houseCalls: 'House Calls',
    doesNotChargeVisitFee: 'No Visit Fee',
    doesNotChargeUrgentCareFee: 'No Urgent Care Fee',
    wellChildExam: 'Well-Child Exams',
    chronicDiseaseManagement: 'Chronic Disease Management',
    healthRiskAssessment: 'Health Risk Assessment',
    biometricScreenings: 'Biometric Screening',
    weightLossManagement: 'Weight Loss Management',
    stressManagement: 'Stress Management',
    fitnessEvaluation: 'Fitness Evaluation',
    sportsPhysical: 'Sports Physicals',
    nutritionEvaluation: 'Nutrition Evaluation',
    medicationsIncluded: 'Acute Medications Included',
    discountLabs: 'Discount on Labs',
    basicLabsIncluded: 'Basic Labs Included',
    discountImaging: 'Discount On Imaging'
};